import queryString from 'query-string';
import callApi, { CallApiResult } from 'src/api';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';

export type EventParticipationFilter = 'REGISTERED' | 'NOT_REGISTERED';

/** R63 Kalender filters; languages absent = all languages, dates yyyy-MM-dd on the event begin. */
export interface EventFilterParams {
    languages?: string[];
    normalizedEventTypeName?: string;
    participation?: EventParticipationFilter;
    dateFrom?: string;
    dateTo?: string;
}

export type EventQueryParams = PageableQueryParams & EventFilterParams;

export interface EventTypeOption {
    normalizedName: string;
    localizedName: string;
}

export interface EventFilterOptions {
    languages: string[];
    types: EventTypeOption[];
}

/* Fetch Events */

export const fetchEvents = (params: EventQueryParams = {}): Promise<CallApiResult> => {
    // arrays go out as repeated params (languages=de&languages=en), matching Spring's List<String> binding
    let query = queryString.stringify(params, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const endpoint = `/api/events${query}`;
    return callApi(endpoint);
};

export const fetchEventFilterOptions = (): Promise<CallApiResult<EventFilterOptions>> =>
    callApi('/api/events/filterOptions');

export interface EventIncludedParticipant {
    partnerName: string;
    status: 'SIGNEDIN' | 'NOTSIGNEDIN';
}

/** The event's signed-up participants whose commission structure contains the caller. */
export const fetchIncludedParticipants = (eventId: string): Promise<CallApiResult<EventIncludedParticipant[]>> =>
    callApi(`/api/event/${eventId}/includedParticipants`);
